(() => {
  if (window.BenchmarkCartCountLoaded) return;

  window.BenchmarkCartCountLoaded = true;

  const selector = '[data-benchmark-cart-count]';
  const storageKey = 'cart-count';
  const currentScript = document.currentScript;

  const normalizeCachedLinks = () => {
    document.querySelectorAll('a[href="/cart"], a[href="/cart?view=benchmark"]').forEach((link) => {
      link.setAttribute('href', '/cart?view=cartrecs');
    });

    document.querySelectorAll('a[href="/collections/all?view=benchmark"]').forEach((link) => {
      if (link.textContent.trim() === 'Shop Products') {
        link.setAttribute('href', '/pages/categories');
      }
    });

    document.querySelectorAll('a[href="/collections/all"]').forEach((link) => {
      link.setAttribute('href', '/collections/all?view=benchmark');
    });

    document.querySelectorAll('a[href="/collections/new-arrivals"]').forEach((link) => {
      link.setAttribute('href', '/collections/new-arrivals?view=compact');
    });

    document.querySelectorAll('a[href="/collections/best-sellers"]').forEach((link) => {
      link.setAttribute('href', '/collections/best-sellers?view=compact');
    });

    document
      .querySelectorAll('a[href="/collections/kitchen-supplies"], a[href="/collections/kitchen-supplies/kitchen-supplies"]')
      .forEach((link) => {
        link.setAttribute('href', '/collections/kitchen-supplies?view=category-hub');
      });

    document.querySelectorAll('a[href="/collections/first-aid"], a[href="/collections/first-aid?page=1"]').forEach((link) => {
      link.setAttribute('href', '/collections/first-aid?view=category-hub');
    });

    document.querySelectorAll('a[href="/collections/storage-organisation"], a[href="/collections/storage-organisation?page=1"]').forEach((link) => {
      link.setAttribute('href', '/collections/storage-organisation?view=category-hub');
    });

    document
      .querySelectorAll('a[href="/collections/sensory"], a[href="/collections/sensory/sensory"]')
      .forEach((link) => {
        link.setAttribute('href', '/collections/sensory?view=category-hub');
      });

    document
      .querySelectorAll(
        'a[href="/collections/toys-gifts"], a[href="/collections/toys-gifts?page=1"], a[href="/collections/toys-gifts?view=resources-hub"]'
      )
      .forEach((link) => {
        link.setAttribute('href', '/collections/toys-gifts?view=resources-hub-v2');
      });

    document
      .querySelectorAll(
        'a[href="/collections/junior-bedding"], a[href="/collections/junior-bedding?page=1"], a[href="/collections/junior-bedding/bedding-linen"]'
      )
      .forEach((link) => {
        link.setAttribute('href', '/collections/junior-bedding?view=bedding-hub');
      });

    document
      .querySelectorAll('a[href="/collections/art-supplies"], a[href="/collections/art-supplies?page=1"]')
      .forEach((link) => {
        link.setAttribute('href', '/collections/art-supplies/art-supplies');
      });

    document
      .querySelectorAll(
        '.category-card a[href="/collections/junior-bedding/bedding-linen"], .benchmark-categories__card[href="/collections/junior-bedding/bedding-linen"]'
      )
      .forEach((link) => {
        link.setAttribute('href', '/collections/junior-bedding?view=bedding-hub');
      });
  };

  const normalizeJuniorBeddingPage = () => {
    if (!window.location.pathname.startsWith('/collections/junior-bedding')) return;

    document.querySelectorAll('.shopify-section').forEach((section) => {
      const heading = section.querySelector('.text-block > h1');

      if (heading?.textContent?.includes('Bibs, Washers')) {
        section.style.display = 'none';
      }
    });

    if (!window.location.pathname.includes('+')) return;

    document
      .querySelectorAll('.benchmark-junior-bedding-filter-hub__subcategories')
      .forEach((subcategories) => {
        subcategories.remove();
      });
  };

  const redirectCachedCollectionPage = () => {
    const staleCollectionPaths = new Map([
      ['/collections/first-aid', '/collections/first-aid?view=category-hub'],
      ['/collections/storage-organisation', '/collections/storage-organisation?view=category-hub'],
      ['/collections/kitchen-supplies', '/collections/kitchen-supplies?view=category-hub'],
      ['/collections/kitchen-supplies/kitchen-supplies', '/collections/kitchen-supplies?view=category-hub'],
      ['/collections/sensory', '/collections/sensory?view=category-hub'],
      ['/collections/sensory/sensory', '/collections/sensory?view=category-hub'],
      ['/collections/art-supplies', '/collections/art-supplies/art-supplies'],
      ['/collections/junior-bedding', '/collections/junior-bedding?view=bedding-hub'],
      ['/collections/toys-gifts', '/collections/toys-gifts?view=resources-hub-v2'],
    ]);

    const redirectTarget = staleCollectionPaths.get(window.location.pathname);

    if (!redirectTarget || `${window.location.pathname}${window.location.search}` === redirectTarget) return;

    window.location.replace(redirectTarget);
  };

  const toCount = (value) => {
    const count = Number.parseInt(value, 10);
    return Number.isFinite(count) && count > 0 ? count : 0;
  };

  const getCurrentCount = () => toCount(document.querySelector(selector)?.textContent);

  const updateBadges = (count) => {
    const nextCount = toCount(count);

    document.querySelectorAll(selector).forEach((badge) => {
      badge.textContent = nextCount > 99 ? '99+' : String(nextCount);
      badge.setAttribute('aria-label', `${nextCount} items in cart`);
    });

    try {
      sessionStorage.setItem(
        storageKey,
        JSON.stringify({
          value: String(nextCount),
          timestamp: Date.now(),
        })
      );
    } catch (_) {
      // Storage can be unavailable in strict browser modes.
    }
  };

  const syncFromCart = async () => {
    if (!document.querySelector(selector)) return;

    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) return;

      const cart = await response.json();
      updateBadges(cart.item_count);
    } catch (_) {
      // If the network request fails, leave the server-rendered count in place.
    }
  };

  const loadCartRecommendations = () => {
    if (!window.location.pathname.endsWith('/cart')) return;
    if (window.BenchmarkCartRecommendationsRequested) return;
    if (customElements.get('benchmark-cart-recommendations')) return;

    const sourceScript =
      currentScript ||
      Array.from(document.scripts).find((script) => script.src.includes('benchmark-cart-count.js'));

    if (!sourceScript?.src) return;

    window.BenchmarkCartRecommendationsRequested = true;

    const script = document.createElement('script');
    script.src = sourceScript.src.replace('benchmark-cart-count.js', 'benchmark-cart-recommendations.js');
    script.defer = true;
    document.head.appendChild(script);
  };

  document.addEventListener('cart:update', (event) => {
    const data = event.detail?.data;

    if (data?.didError) {
      syncFromCart();
      return;
    }

    if (typeof data?.itemCount !== 'number') {
      syncFromCart();
      return;
    }

    const count =
      data.source === 'product-form-component' ? getCurrentCount() + data.itemCount : data.itemCount;

    updateBadges(count);
  });

  window.addEventListener('pageshow', syncFromCart);

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        normalizeCachedLinks();
        normalizeJuniorBeddingPage();
        redirectCachedCollectionPage();
        loadCartRecommendations();
        syncFromCart();
      },
      { once: true }
    );
  } else {
    normalizeCachedLinks();
    normalizeJuniorBeddingPage();
    redirectCachedCollectionPage();
    loadCartRecommendations();
    syncFromCart();
  }
})();
